import React from "react";
import { DotLegalMultiSelect } from "@dotlegal/dotlegal-ui-components";
import { useTranslation } from "@localization/useTranslation.ts";
import useCountryHook from "@common/hooks/useCountryList.ts";

export interface IncidentLogAffectedCountriesFieldProps {
    affectedCountryCodes: Array<string>;
    onChange: (countryCodes: Array<string>) => void;
    disabled: boolean;
}

function IncidentLogAffectedCountriesField(props: IncidentLogAffectedCountriesFieldProps) {
    const { translateString } = useTranslation();
    const { selectableCountries, countriesIsLoading } = useCountryHook();

    return (
        <DotLegalMultiSelect
            isLoading={countriesIsLoading}
            options={selectableCountries}
            chosenOptions={props.affectedCountryCodes}
            onChange={props.onChange}
            placeholder={translateString("affectedCountries")}
            label={translateString("affectedCountries")}
            noOptionsLabel={translateString("noOptions")}
            disabled={props.disabled}
        />
    );
}

export default IncidentLogAffectedCountriesField;
